/**
 * FormInput/FormTextArea — стилевые блоки Input/TextArea (было скопировано
 * 8+ раз: RecInput в processes.tsx, композер news.tsx и т.д.), сведены в один
 * канон. Визуал 1:1 с оригиналами (RecInput / комментарий-блок processes.tsx).
 */
import { Input, TextArea, styled } from 'tamagui'

export const FormInput = styled(Input, {
  name: 'FormInput',
  height: 34,
  fontSize: 13,
  color: '$color',
  backgroundColor: '$bgLayout',
  borderWidth: 1,
  borderColor: '$borderColor',
  borderRadius: 6,
  paddingHorizontal: 9,
  placeholderTextColor: '$tertiary',
  focusStyle: { borderColor: '$primary' },
})

export const FormTextArea = styled(TextArea, {
  name: 'FormTextArea',
  placeholderTextColor: '$tertiary',
  minHeight: 64,
  fontSize: 14,
  color: '$color',
  backgroundColor: '$bgLayout',
  borderWidth: 1,
  borderColor: '$borderColor',
  borderRadius: 7,
  paddingHorizontal: 11,
  paddingVertical: 9,
  focusStyle: { borderColor: '$primary' },
})
